var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonika(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 396.47 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-monika-1{fill:none;}.cls-monika-2{fill:#b1796f;}.cls-monika-3{fill:#20344d;}.cls-monika-4{fill:#5c80a5;}.cls-monika-5{fill:#985625;}.cls-monika-6{clip-path:url(#clip-monika-path);}.cls-monika-7{fill:#a46963;}.cls-monika-8{fill:#11161e;}.cls-monika-9{fill:#be877b;}.cls-monika-10{fill:#8c545f;}.cls-monika-11{fill:#fff;}.cls-monika-12{fill:#9d636c;}.cls-monika-13{fill:#4b80a9;}.cls-monika-14{fill:#cd7436;}.cls-monika-15{clip-path:url(#clip-monika-path-2);}.cls-monika-16{fill:#f3ad00;}.cls-monika-17{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-monika-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-1",
    d: "M147.59,173.51s-9.26,33.76-4.81,51.76l-19.88-.93S84.31,157.69,86.42,150.9l2.1-6.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-monika-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-1",
    d: "M223.88,114.77l47.39-8.71,29.42,35.37,32.36,82.1a6.75,6.75,0,0,1-2.31,7.94l-27.11,19.8-7.15,3.67-13.92,6.68L233.3,233l-6.64-19.15-18.14-27.44,3.3-10.54Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-monika-2",
    points: "70.36 361.92 110.48 434.23 144.75 428.06 125.59 372.94 70.36 361.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-3",
    d: "M279.89,604.81c0-79.13-25.26-170.4-25.26-170.4l-114.74-.36S122.2,541.12,105.18,595.11c-1,3.08-1.82,6.33-2.59,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-4",
    d: "M121,604.81c2.07-7.42,9.42-47.2,11.94-52.24,18.15-36.3,14.47-110.75,14.47-110.75l-42.53-10.24S85.64,546.13,63.17,604.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-5",
    d: "M42.53,604.81H69.89l23.89-96.56s14.32-9.14,17.07-19.81-.61-51.5-.61-51.5l37.17,4.88-6.36-19.67-37.58.64S86.16,429,84,441.82a51.75,51.75,0,0,0-14.32,42.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-2",
    d: "M319.14,215.16S299.85,259,302.37,277s9.21,16,9.21,16S343.39,226.5,319.14,215.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-2",
    d: "M343.13,225.06s14.31-27.61,18.69-32.43c4.53-5,1.13-20.36-15.23,2.44-14.45,20.15-18.82,36.49-18.82,36.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-2",
    d: "M172.07,269.59s21.66-1.07,21.66,12.74-8.49,42.46-8.49,42.46L67.78,360.2,54.44,308.65l-7.86-40.34,6.8-32.7,48.83-11,20.2,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-5",
    d: "M59.84,244.62s-11.43,5.52-8.69,28.8,29.58,69.85,55.06,73.69c0,0,75-7.77,73.17-34.52s-10.15-39.33-10.15-39.33-38-35.1-37.49-44.18l2.15-5.73L146,216.9s61,60.22,74.45,66.18,12.68,107.66,12.68,107.66l-8.35,5.19-99.91-4.72s-58.65-18.57-62.19-41.56-25-70.44-23-79.28,8.25-24.46,8.25-24.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-2",
    d: "M249.66,330.94l1.94,85.13S332,292.09,336.81,283c1-2,4.1-8,5.54-10.26,11.16-17.16,32.9-40.69,40.24-45.65a3.17,3.17,0,0,0,1.34-2.15c.34-2.21-2.8-5.39-16.35,2.71,0,0,11.92-10.17,15.62-12.13s2.44-6.85-1.73-6.85-25.18,15.5-25.18,15.5,11.13-16.21,20.64-23.12a4.92,4.92,0,0,0,1.93-5.28c-.43-1.53-1.67-2.83-4.75-2.5-6.82.74-32.15,21.21-40.62,35.44,0,0-4-18.33-12.51-16.68,0,0-6.52,6.11-.39,12.59l2.78-.47s-.12,4.63,2.89,7.17l-23.11,43.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-2",
    d: "M147.59,173.51s1.74,45.84-3.16,48.84c-6.58,4-21.53,2-21.53,2S84.31,157.69,86.42,150.9l2.1-6.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-monika-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-7",
    d: "M88.52,153.35s35.41,48.16,58.34,34.91L148.14,172Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-8",
    d: "M146.49,173.56s-7.23,33-.1,45c6.83,11.56,28.18,22.59,39.17,13.4s16-25.18,15.41-42.62,2.49-20.48-4.43-32.11-9.14-17.16-6.64-25.18,3.63-53-2-68.11L172.39,67.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-9",
    d: "M171.49,62.29l4.28,19s7.29,28.58,5.36,39.51-10.08,23.76-10.54,32,2.12,20.06-14.08,24.21-70-10.53-74.71-43.56S92.25,69.81,92.25,69.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-10",
    d: "M130.89,145.11l36.44-7.1s-5.22,11.41-13.56,11.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-11",
    d: "M127,143.32s3.34,1.4,4.86,1.34c0,0,2.69,1.53,4.39.47,0,0,4,1.58,5.79.24,0,0,4,.87,6.32-.12,0,0,2.81,1.52,7.19-.35,0,0,3.34.29,5.39-1.29,0,0,1.58.59,4-.82s2.86-8.6,2-9.89-38.8,6.67-38.8,6.67A2.34,2.34,0,0,0,127,143.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-12",
    d: "M128.17,140.1s-2.17.6-.38,2.61,18.28,6.55,30.44,3.4,7.59-13.45,7.59-13.45l4.43-3.21a59.28,59.28,0,0,0-1.78,12.79c-.15,6.84-6.7,10.76-12.28,11.62s-27.33,1.41-33.21-13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-12",
    d: "M123,140.24s23.75-6.82,30.41-7.38,6.8-3.48,16.86-3.41c0,0-6.94,8.93-14.17,9.43S123,140.24,123,140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-8",
    d: "M86.81,83.49S65,100.55,56.71,124,42,151.59,42,151.59s-11.7,9.25-10.67,15.78,1.28,4.87-8.89,9.65S6.79,189,15.23,212c0,0-7,57.29,35.35,40l2.25-5.84s6.37,7.4,21.1-8.35c0,0,13.3,14.72,28.42-1.77,0,0,24.18-6.12,29.84-5.14s9.76-24.82-12-39.83c0,0-28.83-19.68-29.74-50.6s10.92-52.14,10.31-64.56C100.78,75.89,92.18,77.85,86.81,83.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-13",
    d: "M196.65,56.69c-11.26-.13-25-9.92-25-9.92s-11.45-14.88-24.81-31.68S118.57-4.44,76.23,6.67,26.41,64.5,24.41,75.82s6,11.75,13.09,31.27-4.14,41.61-5.83,48.36a26.68,26.68,0,0,0-.38,11.92c-1-6.53,10.67-15.78,10.67-15.78s6.43-4.16,14.75-27.6,30.1-40.5,30.1-40.5c2.3-2.41,18.21-8.68,35.76-11.72,23.48-4.07,49.82-4.67,49.82-4.67l10.44-.49c3.73,10,9.55,30.34,8.92,47.14,16.64-11.49,24.89-36.46,26.89-43.58C220.73,62.71,207.9,56.82,196.65,56.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-14",
    d: "M211.76,107.86c17.4-12.29,47.45-19.33,47.45-19.33l12.06,17.53,29.42,35.37,26.62,71.28-3.8,21.22-20.63,10.15-6.4,10.86-13.92,6.68L233.3,233l-6.64-19.15-18.14-27.44,3.3-10.54-11.17-10.23-14.6-24S194.37,120.14,211.76,107.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-monika-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-16",
    d: "M242.53,222.17S224,197,228.36,181.76c0,0,7.52,7.17,13.47,4.2s-18.54-32.55-14-45.67c0,0,9.62,22.57,21.34,17s-17.84-40.06-17.84-40.06S265.8,133.29,277,150.44s16.09-9.27,10-14.17,15.4,1.75,21.7,19.77,32.09,52.54,32.09,52.54l-5.92,27.64-61.52,42.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-9",
    d: "M118.16,228.5c31.49-6.38,45.2,7.9,51,22.27s40.95,129,40.95,129,8.05-80,11.3-92.75-3.76-48.13-1.75-54.4,5.56-18.6,7-18.78c0,0,5.39,15,8.36,13,0,0,4.09-13.57,6.88-17.85s6.32-19.7,10.22-23.05,15.25-14.12,19.89-12.64,5,3.91,2.42,8.93-10.6,11.71-10.6,11.71a30.33,30.33,0,0,0-3.41,10.74c-.73,6.21-.85,8.15,1.34,10,0,0,13.88-13.64,19-17.17s15-12.78,21.07-9-2.44,10.47-4.39,11.93-19.72,18.26-21.91,22.76-2.31,5.84,2.19,2.56,10.35-8.28,13.76-7.92,6.81,6.46,6.81,16.2-3.28,14.73-4.74,15.09c0,0-9.64,25.57-29.45,42.36,0,0-7.29,25.45-7.6,71.81S253.44,499,228.86,515.18s-66-21.24-89-81.13-35.58-91-35.58-91S65.84,239.09,118.16,228.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-monika-8",
    d: "M109.07,232.11s-4.13-3.75-7.18-3,0,7.38.46,6.9c0,0,30.58,17.5,52.48-6.61C154.83,229.41,132.44,243.43,109.07,232.11Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-monika-11 eyeball",
    cx: 167.71,
    cy: 90.61,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-monika-17 pupil",
    cx: 167.71,
    cy: 90.61,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-monika-11 eyeball",
    cx: 124.45,
    cy: 97.8,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-monika-17 pupil",
    cx: 124.45,
    cy: 97.8,
    r: 7.48
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonika);
export default __webpack_public_path__ + "static/media/Monika.7a580d7736d7443f59496301c86f9c6b.svg";
export { ForwardRef as ReactComponent };